import {
  createMediator,
  type Mediator,
  type TypedEvent,
} from "@/shared/lib/componentHierarchy";

export type NewsArticleImageEvent = {
  type: "news-article-image/failed";
  imageUrl: string;
};

type NewsArticleImageState = {
  readonly failedImageUrl: string | null;
};

export type NewsArticleImageMediator = Mediator<
  NewsArticleImageState,
  NewsArticleImageEvent,
  never
>;

export function isNewsArticleImageEvent(
  event: TypedEvent,
): event is NewsArticleImageEvent {
  return event.type === "news-article-image/failed";
}

export function createNewsArticleImageMediator(): NewsArticleImageMediator {
  return createMediator<NewsArticleImageState, NewsArticleImageEvent>(
    { failedImageUrl: null },
    (state, event) => ({
      status: "handled",
      state:
        state.failedImageUrl === event.imageUrl
          ? state
          : { failedImageUrl: event.imageUrl },
    }),
  );
}
